import * as React from "react";
import DeviceContext from "./../../../service/indentifyDevice";
import EdButton from "../../../generic/edButton";

if (DeviceContext().isDesktop) {
	require("../../../../assets/scss/components/toc/position/positionNoData/positionNoData.scss");
} else {
	require("../../../../assets/scss/components/toc/position/positionNoData/positionNoDataMob.scss");
}
export interface IPositionNoDataProps {
	data: Array<Array<any>>; // data to be filtered
	callBackMeth: (filteredData: Array<any>) => void; // function to be called on clicking of checkbox
	showClrBtn?: boolean;
}

const PositionNoData: React.FC<IPositionNoDataProps> = (props) => {
	return (
		<div className="position_no_data">
			<div className="cir_icon"></div>
			<h2 className="msg">No results found</h2>
			<div>
				{(props.showClrBtn === undefined || props.showClrBtn === true) && (
					<EdButton
						className="ed_button blue-link clear_fltr button"
						value="Clear filters"
						btnTyp="blue-link"
						onClick={() => props.callBackMeth(props.data)}
					/>
				)}
			</div>
		</div>
	);
};

export default PositionNoData;
